// extracted by mini-css-extract-plugin
module.exports = {"logo-item":"styles-module--logo-item--x5GDV","logo-item__link":"styles-module--logo-item__link--1w3pF","logo-item__logo":"styles-module--logo-item__logo--2f-Xm"};